var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg273(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_822_1577)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_822_1577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.199951 3.8147e-06H48.1999V48H0.199951V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_822_1577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.2625 35.783V39.1657C47.2625 40.7839 45.951 42.0964 44.3328 42.0964H38.0091C39.8715 42.0964 41.3807 40.5862 41.3807 38.7248V34.8322C41.3807 33.0938 40.8829 31.3833 39.9032 29.9478C39.248 28.9867 38.4443 28.1441 37.5291 27.4468H38.2328C41.3956 27.4468 44.2675 29.0305 45.9789 31.538C46.83 32.7862 47.2625 34.2729 47.2625 35.783Z",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3807 34.8322V38.7248C41.3807 40.5863 39.8715 42.0963 38.009 42.0963H29.7745C31.8448 42.0963 33.5236 40.4176 33.5236 38.3473V34.0184C33.5236 32.0851 32.9699 30.1836 31.8802 28.5868C30.9631 27.2436 29.7867 26.1073 28.4304 25.2404H30.991C34.6301 25.2404 37.9345 27.0628 39.9032 29.9477C40.8829 31.3832 41.3807 33.0938 41.3807 34.8322Z",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.88 22.5559C39.88 24.0315 39.2824 25.2545 38.3149 26.1083C37.9001 26.4747 37.4181 26.7729 36.8859 26.9929C35.1754 25.8771 33.1415 25.2405 30.9911 25.2405H29.9946C29.8631 25.0475 29.7466 24.8444 29.645 24.63C30.1783 24.3867 30.663 24.0735 31.0861 23.6997C32.1982 22.7172 32.8861 21.3105 32.8861 19.6131C33.9059 19.0156 34.221 18.1217 34.0969 17.1737C33.9376 15.9572 32.8861 15.6972 32.8861 15.6972C32.9858 15.0401 33.0054 14.4481 32.9579 13.915C33.4696 13.8404 34.0028 13.8105 34.5379 13.8105C37.4881 13.8105 40.5091 14.9897 39.88 19.1527C39.88 19.1527 40.7935 19.3792 40.9324 20.4362C41.0405 21.2602 40.7664 22.0377 39.88 22.5559Z",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.886 19.6131C32.886 21.3106 32.1981 22.7172 31.0861 23.6996C30.3039 24.3904 29.3112 24.8723 28.2002 25.096C26.3852 23.9932 24.2674 23.3641 22.034 23.3529C21.7254 23.0248 21.4588 22.6594 21.2417 22.2595C21.5381 22.074 21.8169 21.8671 22.075 21.6387C23.312 20.5462 24.0773 18.9821 24.0773 17.0936C25.2108 16.4299 25.5612 15.4353 25.4232 14.382C25.2462 13.0285 24.0773 12.7395 24.0773 12.7395C24.2469 11.6153 24.2087 10.6609 24.0064 9.85451C24.8584 9.62988 25.7971 9.54973 26.7395 9.54973C30.1343 9.54973 33.6103 10.9069 32.886 15.6972C32.886 15.6972 33.9375 15.9573 34.0969 17.1737C34.2208 18.1217 33.9058 19.0156 32.886 19.6131Z",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3306 42.0961H29.7742C31.8448 42.0961 33.5234 40.4176 33.5234 38.347V34.0182C33.5234 32.0854 32.9696 30.1835 31.8801 28.587C29.6904 25.3781 26.0162 23.3517 21.9694 23.3517H12.6914C8.64467 23.3517 4.97042 25.3781 2.78061 28.587C1.69123 30.1835 1.13745 32.0854 1.13745 34.0182V38.347C1.13745 40.4176 2.81604 42.0961 4.88651 42.0961H5.25279H7.15883",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2672 23.4213V23.4222C23.2672 23.4222 23.009 28.5532 17.3308 28.5532C11.6517 28.5532 11.3936 23.4233 11.3936 23.4233V23.4213C11.8212 23.376 12.2538 23.3519 12.6911 23.3519H21.9695C22.4068 23.3519 22.8395 23.376 23.2672 23.4213Z",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.423 14.3817C25.2457 13.0283 24.0771 12.7393 24.0771 12.7393C24.882 7.41222 21.0167 5.90359 17.2414 5.90359C13.4661 5.90359 9.74098 7.05437 10.4056 12.7393C10.4056 12.7393 9.23698 13.0283 9.0597 14.3817C8.9217 15.4352 9.27233 16.4299 10.4056 17.094C10.4056 20.8693 13.4661 23.3517 17.2414 23.3517C21.0167 23.3517 24.0771 20.8693 24.0771 17.094C25.2105 16.4299 25.561 15.4352 25.423 14.3817Z",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15894 34.7716V42.096",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5322 34.7716V42.0964",
    stroke: "#102E7A",
    strokeWidth: 1.41,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_822_1577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.199951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg273);
export default __webpack_public_path__ + "static/media/svg273.49e853877254e261257b7dad9644b045.svg";
export { ForwardRef as ReactComponent };